<button mat-mini-fab (click)="abrirAjuda(manual)" color="primary" [title]="titleAjuda">
    <mat-icon aria-label="Ajuda">help</mat-icon>
  </button>